import { useContext, useState } from "react";
import SearchButton from "./components/SearchButton/SearchButton";
import PropTypes from "prop-types";
import SearchModal from "../components/SearchModal/SearchModal";
import SearchButtonSkeleton from "./components/SearchButtonSkeleton/SearchButtonSkeleton";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useIntl } from "react-intl";

const MiniSearch = ({ itinerary, isLoading = false }) => {
	const { track } = useAnalytics();
	const { formatMessage } = useIntl();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;
	const showSearchButton = isMobile || (!isMobile && !isModalOpen);

	if (isLoading) {
		return <SearchButtonSkeleton />;
	}

	return (
		<>
			{showSearchButton && (
				<SearchButton
					onClick={() => {
						setIsModalOpen(true);
						track("listing-sdp-mini-engine-modify");
					}}
					itinerary={itinerary}
				/>
			)}

			<SearchModal
				title={formatMessage({ id: "sdp.search.home.input.label" })}
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
			/>
		</>
	);
};

MiniSearch.propTypes = {
	isLoading: PropTypes.bool,
	itinerary: PropTypes.shape({
		from: PropTypes.string,
		to: PropTypes.string.isRequired,
		stopover: PropTypes.string,
		dates: PropTypes.shape({
			from: PropTypes.number.isRequired,
			to: PropTypes.number.isRequired,
		}).isRequired,
		travelerCount: PropTypes.number.isRequired,
		roomCount: PropTypes.number.isRequired,
	}).isRequired,
};

export default MiniSearch;
